import { FC } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckIcon from '@mui/icons-material/Check';
import * as S from './styled';

const Select: FC<any> = ({
  name,
  label,
  options,
  selectedValue,
  onChange,
  mode = 'string',
  disabled = false,
  rules = {},
  register,
  error = '',
}) => {
  const selectProps = rules && register ? register(name, rules) : {};
  return (
    <div
      style={{
        marginBottom: 16,
        pointerEvents: disabled ? 'none' : 'auto',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        width: '100%',
      }}
    >
      <S.SelectLabel error={error}>{label}</S.SelectLabel>
      <S.CustomSelect
        {...selectProps}
        error={!!error}
        name={name}
        inputProps={{ 'aria-label': label }}
        fullWidth
        variant="outlined"
        label=""
        IconComponent={KeyboardArrowDownIcon}
        displayEmpty
        value={mode === 'string' ? selectedValue || '' : selectedValue?.name || ''}
        renderValue={(selected: any) => {
          if (!selected) return 'Select...';
          return mode === 'string'
            ? options.find((opt) => {
                return opt.label === selected;
              })?.label || selected
            : options.find((opt) => {
                return opt.name === selected;
              })?.name || selected; // ✅ Исправлено для объектов
        }}
        onChange={(e) => {
          const selectedOption =
            mode === 'string'
              ? options.find((opt) => {
                  return opt.label === e.target.value;
                })
              : options.find((opt) => {
                  return opt.name === e.target.value;
                });
          onChange(
            selectedOption ? (mode === 'string' ? selectedOption.label : selectedOption) : null
          );
        }}
        MenuProps={{
          disableScrollLock: true,
          PaperProps: {
            sx: {
              marginTop: '2px',
              borderRadius: '8px',
              boxShadow:
                '0px 20px 24px -4px rgba(0, 0, 0, 0.08), 0px 8px 8px -4px rgba(0, 0, 0, 0.03)',
              maxHeight: '245px',
              overflowY: 'auto',
              '&::-webkit-scrollbar': { width: '4px' },
              '&::-webkit-scrollbar-thumb': {
                background: '#D8DBE8',
                borderRadius: '10px',
                transition: 'background 0.2s ease-in-out',
              },
              '&::-webkit-scrollbar-thumb:hover': { background: '#BFC3D4' },
              '&::-webkit-scrollbar-thumb:active': { background: '#A5AABF' },
            },
          },
          MenuListProps: {
            sx: {
              padding: '0px',
              borderRadius: '8px',
            },
          },
        }}
      >
        <S.CustomMenuItem value="" disabled>
          Select...
        </S.CustomMenuItem>
        {options?.map((option: any) => {
          const optionValue = mode === 'string' ? option.label : option.name || option.label; // Если объект - используем name, если label - используем label

          const isSelected =
            mode === 'string'
              ? selectedValue === option.label
              : selectedValue?.name === option.name && selectedValue?.id === option.id;
          return (
            <S.CustomMenuItem key={option.label || option.name} value={optionValue}>
              {option.label || option.name}
              {isSelected && (
                <S.Checkmark>
                  <CheckIcon />
                </S.Checkmark>
              )}
            </S.CustomMenuItem>
          );
        })}
      </S.CustomSelect>
      {error ? <S.ErrorMessage>{error}</S.ErrorMessage> : null}
    </div>
  );
};

export default Select;
